// version.js — single source of truth for the app version string.
//
// In production the value is substituted at bundle time by esbuild's
// `define` (see build.mjs) using the version field from package.json.
//
// In unbuilt dev (the source-is-the-deployable path), the identifier is
// undeclared. `typeof` is the one safe way to test for an undeclared
// global without throwing ReferenceError, so the fallback below works in
// both bundled and unbundled paths.

export const VERSION = (
  typeof __KFE_VERSION__ !== "undefined" ? __KFE_VERSION__ : "dev"
);
